import uuid from "react-uuid";

export const getFileExtension = (url) => {
  const filename = url.split(".").pop();
  
  return filename.split("?").shift();
};

export const generateFileName = (type = "document", extension) => {
  const timeInMs = Date.now();

  const unique = uuid();

  switch (type) {
    case "document":
      return `DOC-ID-${unique}-${timeInMs}.${extension}`;

    case "photo":
      return `IMG-ID-${unique}-${timeInMs}.${extension}`;

    case "video":
      return `VID-ID-${unique}-${timeInMs}.${extension}`;

    default:
      return `DOC-ID-${unique}-${timeInMs}.${extension}`;
  }
};
